import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Cover from '../cover'
import Slide from '../slide'
import Slider from '../slider'
import TitleCard from '../title-card'

class Shelf extends Component {
	constructor(props) {
		super(props)

		this.state = {
      selectedTitleId: 0,
			titleCardViewable: false,
    }

    this.setSelectedTitleId = this.setSelectedTitleId.bind(this)
    this.showTitleCard = this.showTitleCard.bind(this)
    this.hideTitleCard = this.hideTitleCard.bind(this)
	}

	setSelectedTitleId(titleId) {
    this.setState({
      selectedTitleId: titleId,
    })
  }

  showTitleCard(titleId) {
  	this.setState({
      selectedTitleId: titleId,
      titleCardViewable: true,
    })
  }

  hideTitleCard() {
  	this.setState({
      titleCardViewable: false,
    })
  }

	render() {
		const {
			header,
			titles,
		} = this.props

		const slides = titles.map((title, index) => {
	    return (
	      <Slide key={index}>
	        <Cover
	        	imageUrl={title.artworkUrls.cover}
	        	linkTo={`/title/${title.videoId}`}
	        	setSelectedTitleId={this.setSelectedTitleId}
	        	titleId={index}
	        	titleName={title.name}
	        	showTitleCard={this.showTitleCard}
	        />
	      </Slide>
	    )
	  })

	  const selectedTitle = titles[this.state.selectedTitleId]

		return (
			<React.Fragment>
				<div className="shelf">
					<h2 className="shelf__header">
		        <span className="shelf__header-text">{header}</span>
		      </h2>
		      <Slider slides={slides} />
				</div>
				<TitleCard
					title={selectedTitle}
					show={this.state.titleCardViewable}
					hide={this.hideTitleCard}
				/>
			</React.Fragment>
		)
	}
}

Shelf.defaultProps = {
	header: '',
	titles: [],
}

Shelf.propTypes = {
	header: PropTypes.string,
	titles: PropTypes.array,
}

export default Shelf



// WEBPACK FOOTER //
// ./src/mobile/components/shelf/index.js